import { useQuery } from "@tanstack/react-query";
import type { MarketStatus } from "@chartandgo/shared";
import { fetchMarketStatus } from "../api/market.js";

export function useMarketStatus() {
  return useQuery<MarketStatus>({
    queryKey: ["market-status"],
    queryFn: fetchMarketStatus,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: 1,
  });
}
